import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EmployeeService } from 'src/app/_Core/_Services/employee.service';

@Component({
  standalone: false,
  selector: 'app-meetingroom-cancel-portal',
  templateUrl: './meetingroom-cancel-portal.component.html',
  styleUrls: ['./meetingroom-cancel-portal.component.scss']
})
export class MeetingroomCancelPortalComponent implements OnInit {
  @Input() id: string;
  @Input() meetingRoomData: string;

  constructor(
    public modal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private router: Router,
    private employeeService: EmployeeService,
  ) {
  }

  ngOnInit(): void { }

  cancelBooking() {
    this.employeeService.cancelBookedMeetingRoom(this.meetingRoomData).subscribe((res) => {
      this.modal.close();
      // this.modal.dismiss();
      setTimeout(() => {
        location.reload();
      }, 10000);
    });
  }
}

